import React,{useState,useEffect} from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter,useHistory,NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import StepConnector from "@material-ui/core/StepConnector";
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import {
  TRIP_STATUS,
  TRIP_DISPLAY_STATUS,
  TRIP_ACTIONS,
  TRIP_STATUS_DIALOG_TITLES,
  TRIP_STATUS_DIALOG_LABELS,
  PAYMENT_CHIPS,
  TRIP_ACTIONS_DWEB_PARTY,
  TRIP_ACTIONS_DWEB
} from "../../../store/constants";
import {
  getTripDetailsV3,
  updateTripStatus,
  addNewPodDweb,
  deleteTripPod,
  createTripNotes,
  deleteTripLrGcn
} from "../../../store/actions/tripActionCreator";
import { numberFormat, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import ComingSoonModal from '../ComingSoonModal/comingSoonModal';
import clsx from 'clsx';
import S3Uploader from '../s3Uploader/s3Uploader';
import ImageViewDialog from '../ImageComponent/ImageViewDialog';
import ImageUploadDialog from '../ImageComponent/ImageUploadDialog'
const useStyles = makeStyles((theme) => ({
    info: {
      padding: '16px 24px',
      overflow:'auto',
      //height:'384px'
      // height:'calc(100vh - 377px)'
    },
    infoSettled: {
      padding: 24,
      overflow:'auto',
      //height:'384px'
      // height:'calc(100vh - 309px)'
    },
    tripVerticalStepper: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop:0
    },
    stepContent:{
      marginTop:0,
      marginLeft:8,
      borderLeft:'2px solid #bdbdbd'
    },
    completedStep:{
      '& .custom-step-content':{
        borderLeft:'2px solid #008556 !important'
      },
      '& .MuiStepLabel-root':{
        "&:before": {
          background: "#008556 !important"
        },
        "&:after": {
          background: "#008556 !important"
        }
      }
    },
    stepContentDiv:{
      padding:'11px 24px'
    },
    tripVerticalStepperLabel:{
      fontWeight:600,
      fontSize:14
    },
    actionButton:{
      textTransform:'capitalize',
      fontWeight:300,
      color:'#0033cc',
      borderColor:'#0033cc'
    },
    actionButtonImage:{
      textTransform:'capitalize',
      fontWeight:300,
      color:'#0033cc',
      borderColor:'#f1f1f1',
      padding:'12px 12px',
      minWidth:40,
      height:40,
      width:40,
      borderRadius:8
    },
    stepRoot:{
      '&:first-child .MuiStepLabel-vertical':{
        "&:after": {
          position: "absolute",
          content: '""',
          top: 25,
          left: 8,
          right: 0,
          width: 2,
          height: 15,
          background: "#c7c7c7"
        }
      },
      '&:last-child .MuiStepLabel-vertical':{
        "&:before": {
          position: "absolute",
          content: '""',
          top: 0,
          left: 8,
          right: 0,
          width: 2,
          height: 15,
          background: "#c7c7c7"
        }
      },
      '&:not(:last-child):not(:first-child) .MuiStepLabel-vertical':{
        "&:before": {
          position: "absolute",
          content: '""',
          top: 0,
          left: 8,
          right: 0,
          width: 2,
          height: 15,
          background: "#c7c7c7"
        },
        "&:after": {
          position: "absolute",
          content: '""',
          top: 25,
          left: 8,
          right: 0,
          width: 2,
          height: 15,
          background: "#c7c7c7"
        }
      }
    },
    verticalLabel:{
      position:'relative',
      '& .MuiStepLabel-iconContainer':{
        paddingRight:24
      },
      '& .MuiStepLabel-completed':{
        fontWeight:600
      },
      '& .MuiStepLabel-iconContainer':{
      }
    },
    dateLabel:{
      fontWeight:400,
      fontSize:12
    },
    photoIcon:{
      fontSize:16
    }
}));
const TripTimelineConnector = withStyles({
  /*alternativeLabel: {
    top: 9,
    left: "calc(-67% + 16px)",
    right: "calc(35% + 16px)",
    fontSize: 12,
  },*/
  active: {
    "& $line": {
      borderColor: "#c7c7c7",
    },
  },
  completed: {
    "& $line": {
      borderColor: "#008556",
      minHeight: 2,
      maxHeight: 2,
      height:2,
      /*"&:before": {
        position: "absolute",
        content: '""',
        top: -13,
        left: 0,
        right: 0,
        width: 2,
        height: 14,
        background: "#008556 !important"
      },
      "&:after": {
        position: "absolute",
        content: '""',
        top: 6,
        left: 0,
        right: 0,
        width: 2,
        height: 56,
        background: "#008556 !important"
      }*/
    },
  },
  line: {
    borderColor: "#c7c7c7",
    borderTopWidth: 3,
    borderRadius: 1,
  },
  lineVertical: {
    minHeight: 2,
    borderLeftWidth: 2,
  },
  vertical: {
    marginLeft: 8,
    //marginTop:-15,
    position:'relative',
    paddingBottom: 0,
    /*"&:before": {
      position: "absolute",
      content: '""',
      top: -13,
      left: 0,
      right: 0,
      width: 2,
      height: 14,
      background: "#c7c7c7"
    },
    "&:after": {
      position: "absolute",
      content: '""',
      top: 6,
      left: 0,
      right: 0,
      width: 2,
      height: 56,
      background: "#c7c7c7"
    }*/
  },
})(StepConnector);
const tripStepIconStyles = makeStyles({
  root: {
    color: "#eaeaf0",
    display: "flex",
    //height: 22,
    alignItems: "center",
  },
  active: {
    color: "#784af4",
  },
  circle: {
    borderRadius: "50%",
    backgroundColor: "#c7c7c7",
    fontSize: 18,
    color: "#c7c7c7",
  },
  completed: {
    //backgroundColor: "#008556",
    color: "#008556",
    zIndex: 1,
    borderRadius: "50%",
    fontSize: 20,
  }
});
function TripStepIcon(props) {
  const classes = tripStepIconStyles();
  const { active, completed } = props;
  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <CheckCircleIcon className={classes.completed} />
      ) : (
          <FiberManualRecordIcon className={classes.circle} />
        )}
    </div>
  );
}
const TripTimeline = (props) => {
  const {location,user,dispatchAddNewPod,dispatchDeleteTripPod,dispatchDeleteTripLrGcn,dispatchTripDetailsAction,dispatchCreateTripNote,fetchTripDetails} = props;
  const classes = useStyles();
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let tripDetails = user.singleTripData ? user.singleTripData : {};
  let tripId = tripDetails && tripDetails.id?tripDetails.id:path[path.length-1];
  let tripStatus = tripDetails && tripDetails.status?tripDetails.status:'';
  let hiredTrip = tripDetails && tripDetails.vehicle && tripDetails.vehicle.ownershipType && tripDetails.vehicle.ownershipType == 'HIRED'?true:false;
  let vendorId = hiredTrip && tripDetails && tripDetails.vehicle && tripDetails.vehicle.vendorId ?tripDetails.vehicle.vendorId:0;
  let title ='';
  const fetchTrip = (tripId)=>{
      dispatchTripDetailsAction(tripId, () => {
      });
  }
  const getEventDate = (eventName) => {
    if (tripDetails && tripDetails.tripEvents) {
      if (eventName === 'Settled') {
        eventName = 'PAYMENT_RECEIVED'
      }
      eventName = eventName.replace(' ', '_');
      const event = tripDetails.tripEvents.filter((e) => {
        return (e["event"].toLowerCase() == eventName.toLowerCase())
      })[0]
      if (event && event["eventDate"]) {
        return getDateInStringDDMMMYYYY(event["eventDate"]);
      }
    }
    return null;
  }
  const [tripPODS, setTripPODS] = React.useState(tripDetails.tripPods?tripDetails.tripPods:[]);
  const [images, setImages] = React.useState([]);
  const [active, setActive] = React.useState(0);
  const [multiple, setMultiple] = React.useState(false);
  const [header, setHeader ]= React.useState('');
  const [uploadText, setUploadText ]= React.useState('');
  const [imagesViewerOpen, setImagesViewerOpen] = React.useState(false);
  const [imagesUploaderOpen, setImagesUploaderOpen] = React.useState(false);
  const [uploadType, setUploadType] = React.useState('');
  const handleImagesViewerOpen = (images,index,header)=>{
    setHeader(header);
    setImages(images);
    setActive(index);
    setImagesViewerOpen(true);
  }
  const handleImagesViewerClose = ()=>{
    setImagesViewerOpen(false);
  }
  const handleImagesViewerConfirm= ()=>{
    setImagesViewerOpen(false);
  }
  const handleImagesUploaderOpen = (header,type,uploadText)=>{
    setHeader(header);
    setUploadText(uploadText);
    setUploadType(type);
    if (type =='LR') {
      setMultiple(false);
    }else if (type =='POD') {
      setMultiple(true);
    }
    setImagesUploaderOpen(true);
  }
  const handleImagesUploaderClose = ()=>{
    setImagesUploaderOpen(false);
    if (tripId) {
      fetchTrip(tripId)
    }
  }
  const handleImagesUploaderConfirm= (images)=>{
    if (images.length>0) {
      if (uploadType =='LR') {
        let notesRequest = {
          notes:[],
          'tripStatus': 'STARTED'
        }
        images.forEach(element => {
          let note={
            "note": "START_IMAGE",
            "s3Link": element,
            "noteReceivedDate": getRequestTimeInMillis(new Date())
          }
          notesRequest.notes.push(note);
        });
        dispatchCreateTripNote(tripId, notesRequest,()=>{
          setImagesUploaderOpen(false);
          fetchTripDetails()
        }, null);
      }else if (uploadType =='POD') {
        let newPodRequest = {
          podImageS3Links: images,
          podReceivedDate: getRequestTimeInMillis(new Date())
        }
        dispatchAddNewPod(tripId, newPodRequest, ()=>{
            setImagesUploaderOpen(false);
            fetchTripDetails()
        }, null);
      }
    }else{
      setImagesUploaderOpen(false);
    }
  }

  /*useEffect(() => {
    setTripPODS(tripDetails.tripPods?tripDetails.tripPods:[]);
  }, [tripPODS])*/
  const handleNewPOD = (file) => {
    var newPodRequest = {
      podImageS3Links: [file],
      podReceivedDate: getRequestTimeInMillis(new Date())
    }
    dispatchAddNewPod(tripDetails.id, newPodRequest, null, null);
  }
  const handleDeletePOD = (podId) => {
    dispatchDeleteTripPod(tripId, podId,
      () => {
        fetchTripDetails()
      }, null);
  }
  const handleDeleteLRGCN = (id) => {
    dispatchDeleteTripLrGcn(tripId, id,
      () => {
        fetchTripDetails()
      }, null);
  }
  const handlePOD = (file) => {
    var newPOD = [...tripPODS];
    newPOD.push(file);
    setTripPODS(newPOD);
  };
  const handleCTADeletePOD = (index) => {
    var newPOD = [...tripPODS];
    newPOD.splice(index, 1);
    setTripPODS(newPOD);
  }
  const [comingSoonOpen, setComingSoonOpen] = useState(false);
  const handleComingSoonOpen = ()=>{
    setComingSoonOpen(true);
  }
  const handleComingSoonClose = ()=>{
    setComingSoonOpen(false);
  }
  const getImages = (images)=>{
    let steps =[];
    if (images && Array.isArray(images)) {
        for (const key in images) {
          if (Object.hasOwnProperty.call(images, key)) {
            const element = images[key];
            let image={
              label:'',
              imgPath:null
            }
            if (element && Object.hasOwnProperty.call(element, 'podLink')&& element.id && element.podLink) {
              image.label='POD Image'
              image.imgPath=element.podLink;
            }
            if (Object.hasOwnProperty.call(element, 's3Link') && element.id && element.s3Link) {
              image.label='LR/GCN Image'
              image.imgPath=element.s3Link;
            }
            steps.push({...image,...element});
          }
        }
        return steps;
    }
    return[];
  }
  function getStepContent(step) {
    switch (step) {
      case 0:
        return <></>;
      case 'Started':
        return <>
        <Grid
          container
          spacing={1}
          direction="row"
          justify="flex-start"
          alignItems="center"
        >
          {tripDetails && tripDetails.tripGcns && tripDetails.tripGcns.length>0 &&<Grid item>
              {tripDetails.tripGcns.filter((img)=>img && img.s3Link != null).map((img, index) => (
                img && img.id && img.s3Link?<div className="S3Uploader-image-div"> 
                    <img className="S3Uploader-imagesrc" onClick={()=>handleImagesViewerOpen(tripDetails.tripGcns,index,'LR/GCN Images')} src={img && img.s3Link?img.s3Link:img} alt="fileUpload" />
                    <img className="S3Uploader-imageclose" src={require("../../../assets/close-icon.svg")} onClick={() => {handleDeleteLRGCN(img.id)}}></img>
                </div> :null 
              ))}
          </Grid>}
          <Grid item>
            {<Button
              variant="outlined"
              color="primary"
              onClick={()=>{handleImagesUploaderOpen('Upload LR/GCN Images','LR','Add LR/GCN')}}          
              className={tripDetails && tripDetails.tripGcns && tripDetails.tripGcns.length>0?classes.actionButtonImage:classes.actionButton}
            >
              {tripDetails && tripDetails.tripGcns && tripDetails.tripGcns.length>0?<AddAPhotoIcon className={classes.photoIcon} />:'Add LR/GCN'}
            </Button>}
          </Grid>
        </Grid>
        {/* <Button
          variant="outlined"
          color="primary"
          onClick={()=>{handleImagesUploaderOpen('Upload LR/GCN Images','LR')}}          
          className={classes.actionButton}
        >
          Add LR/GCN
        </Button> */}
        </>;
      case 'POD Received':
        return <>
        <Grid
          container
          spacing={1}
          direction="row"
          justify="flex-start"
          alignItems="center"
        >
          {tripDetails && tripDetails.tripPods &&  tripDetails.tripPods.length>0 &&<Grid item>
              {tripDetails.tripPods.filter((img)=>img && img.podLink != null).map((podImage, index) => (
                podImage && podImage.id && podImage.podLink?<div className="S3Uploader-image-div"> 
                    <img className="S3Uploader-imagesrc" onClick={()=>handleImagesViewerOpen(tripDetails.tripPods,index,'POD Images')} src={podImage && podImage.podLink?podImage.podLink:null} alt="fileUpload" />
                    <img className="S3Uploader-imageclose" src={require("../../../assets/close-icon.svg")} onClick={() => {handleDeletePOD(podImage.id)}}></img>
                </div>:null  
              ))}
          </Grid>}
          {tripStatus == 'POD_RECEIVED' && <Grid item>
            {/* <S3Uploader toggle={true} handleFile={handlePOD} text='Add POD' /> */}
            {<Button
              variant="outlined"
              color="primary"
              onClick={()=>{handleImagesUploaderOpen('Upload POD Image','POD','Add POD')}}
              className={tripDetails && tripDetails.tripPods &&  tripDetails.tripPods.length>0?classes.actionButtonImage:classes.actionButton}
            >
              {tripDetails && tripDetails.tripPods &&  tripDetails.tripPods.length>0?<AddAPhotoIcon className={classes.photoIcon} />:'Add POD'}
            </Button>}
          </Grid>}
        </Grid>
        {/* <Button
          variant="outlined"
          color="primary"
          onClick={handleComingSoonOpen}
          className={classes.actionButton}
        >
          Add POD
        </Button> */}
        </>;
      default:
        return (
          <>
          </>
        );
    }
  }
  return (
    <div className={tripStatus !='PAYMENT_RECEIVED'?classes.info:classes.infoSettled}>
     <Stepper
        activeStep={TRIP_STATUS[tripDetails.status]}
        connector={<TripTimelineConnector className={classes.connector} />}
        className={classes.tripVerticalStepper}
        orientation="vertical"
      >
        {TRIP_DISPLAY_STATUS.map((label) => (
          <Step key={label} classes={{root:classes.stepRoot,completed:classes.completedStep}}>
            <StepLabel
              classes={{
                label:classes.tripVerticalStepperLabel,
                vertical: classes.verticalLabel,
                completed:classes.completedStep
              }}
              StepIconComponent={TripStepIcon}
            >
            <span>{label}</span>
            <br />
            <span className={classes.dateLabel}>{getEventDate(label)}</span>
            </StepLabel>
            {label != 'Settled' && <div className={clsx(classes.stepContent,'custom-step-content')}>
              <div>
                <div className={classes.stepContentDiv}>
                  {getStepContent(label)}
                </div>
              </div>
            </div>}
          </Step>
        ))}
      </Stepper>
      {comingSoonOpen && <ComingSoonModal open={comingSoonOpen} onClose={handleComingSoonClose} />}
      {imagesViewerOpen && <ImageViewDialog images={getImages(images)} active={active} header={header} open={imagesViewerOpen} onClose={handleImagesViewerClose} onConfirm={handleImagesViewerConfirm} />}
      {imagesUploaderOpen && <ImageUploadDialog header={header} multiple={multiple} uploadText={uploadText} open={imagesUploaderOpen} onClose={handleImagesUploaderClose} onConfirm={handleImagesUploaderConfirm} />}
    </div>
  );
}
const TripTimelineRouter = withRouter(TripTimeline);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchAddNewPod: (tripId, data, onSuccess, onFailure) => { dispatch(addNewPodDweb(tripId, data, onSuccess, onFailure)) },
  dispatchDeleteTripPod: (tripId, podId, onSuccess, onFailure) => { dispatch(deleteTripPod(tripId, podId, null, onSuccess, onFailure)) },
  dispatchDeleteTripLrGcn: (tripId, id, onSuccess, onFailure) => { dispatch(deleteTripLrGcn(tripId, id, null, onSuccess, onFailure)) },
  dispatchCreateTripNote: (tripId, data, onSuccess, onFailure) => { dispatch(createTripNotes(tripId, data, onSuccess, onFailure)) },
  dispatchTripDetailsAction: (tripId, onSuccess,onError) =>
    dispatch(getTripDetailsV3(tripId,onSuccess,onError)),
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TripTimelineRouter);